/*
 * @Descripttion:
 * @version:
 * @Author: Raoxf
 * @Date: 2022-05-28 22:05:38
 * @LastEditors: Raoxf
 * @LastEditTime: 2022-12-29 21:19:05
 */

export default (Vue) => {
  return [
    {
      title: "联系人",
      key: "userName",
      align: 'center'
    },
    {
      title: "手机号",
      key: "phone",
      align: 'center',
    },
    {
      title: "技能备注",
      key: "remark",
      align: 'center'
    },
    {
      title: "类型",
      key: "type",
      align: 'center',
      render: (h, { row }) => {
        return h('div', row.type == 1 ? '服务商' : '保洁员')
      }
    },
    {
      title: "创建时间",
      key: "createDt",
      align: 'center'
    },
    {
      title: "操作",
      key: "action",
      align: 'center',
      width: 150,
      render: (h, { row }) => {
        return h('div', [
          h('el-button', {
            props: {
              type: 'text',
              size: 'small'
            },
            on: {
              click: () => {
                Vue.openReviewDialog(row);
              }
            }
          }, '审核')
        ])
      }
    },
  ]
}